import React from 'react';

import { ContentSection, ContentSectionProps } from 'Storybook/components/local/ContentSection';

type SEOContentBlockProps = ContentSectionProps
  & {
    className?: string;
    ref: React.RefObject<HTMLDivElement> | ((ref: HTMLDivElement | null) => void);
  };

export const SEOContentBlock = (
  {
    className,
    ref,
    ...props
  }: SEOContentBlockProps,
) => (<div ref={ref} {...{ className }} data-testid='content-section'>
  <ContentSection {...{ ...props }} />
</div>);
